import { Link } from 'react-router';

import './Button.scss';

export const Button = ({
  className,
  'data-testid': dataTestId,
  link,
  openInNewTab,
  reloadDocument,
  text,
  width,
}: {
  className?: string;
  'data-testid'?: string;
  link: string;
  openInNewTab?: boolean;
  reloadDocument?: boolean;
  text: string;
  width?: string;
}) => (
  <Link
    to={link}
    reloadDocument={reloadDocument}
    {...(openInNewTab && { rel: 'noopener noreferrer', target: '_blank' })}
  >
    <div
      className={`button ${className || ''}`.trim()}
      data-testid={dataTestId}
      style={{ minWidth: width || '120px' }}
    >
      <p className="button__text">{text}</p>
    </div>
  </Link>
);

